// extracted by mini-css-extract-plugin
export var fullGrid = "_3q-3";
export var pdpPreviewContainer = "_3q-1";
export var previewContainer = "_3q-0";
export var togglePreviewContainer = "_3q-2";